// extracted by mini-css-extract-plugin
export default {"text":"donut_text__dDOLP","valueText":"donut_valueText__mEhQV","seperatorText":"donut_seperatorText__cUCqL","maxText":"donut_maxText__zuI6f","unitText":"donut_unitText__5ih-7"};